export default class NotImplementedError extends Error {
  constructor(message = "It should be implemented") {
    super(message);
    this.name = "NotImplementedError";
  }
}
